import React from 'react';
import Notification from "../Notification";
import { translate } from "../../Services/translation";
import { toggle } from "../../Actions/Cart.action";
import { useDispatch, useSelector } from "react-redux";

const VariantNotification = () => {
    const { message, type } = useSelector((state) => state.productDetailNotification);
    const dispatch = useDispatch();

    if(!message){
        return null;
    }

    return (
        <div className="product-variant__notifications-container">
            <Notification
                info={type !== 'error'}
                buttonText={type === 'error' ? null : translate(
                    'product-variant.notification.cart.url'
                )}
                onClick={() => dispatch(toggle())}
                text={message}
            ></Notification>
        </div>
    );
};

export default VariantNotification;
